import { useState } from "react";
import { IconButton } from "../atoms/buttons";
import { TextAtom } from "../atoms/TextAtom";
import { LABELS, STATUS } from "../constants/statusLabels";
import { Chip } from "../molecule/Chip";

export function renderCell(row, col) {
    const isMobile = window.innerWidth <= 768;
    switch (col.key) {
        case "status":
            return <Chip size={isMobile ? "small" : "medium"} key={col.key} label={LABELS[row[col.key]] || "Onbekend"} variant={STATUS[row[col.key]] || "not-found"} />;
        case "action":
            return <IconButton key={col.key} className={row.action ? "actie-icon" : "disabled"} icon2={row.action ? "dots-vertical" : "minus"} size={24} />;
        default:
            return col.key === "note" ? <TableCell key={col.key} value={row[col.key]} isMobile={isMobile} /> : <TextAtom key={col.key} className={"phone-text-wrap"} title={row[col.key]} />;
    }
}


export function TableCell({ value, isMobile }) {
  const [expanded, setExpanded] = useState(false);
    const empty = value === "Geen notitie" || value === "" || value === null || value === undefined;
    const collapse = () => {
        if (empty){  
            return;
        }
        setExpanded(!expanded);
    }
  return (
    <TextAtom
      className={`phone-text-wrap table-cell ${expanded ? "expanded" : ""} ${empty && "no-note"}`}
      title={value}
      onClick={(e) => { e.stopPropagation(); collapse();}}
    >
      {value}
    </TextAtom>
  );
}